module.exports = __webpack_public_path__ + "static/media/logout.82dde7af.svg";